import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { CreateCustomConditionPayload } from './types';

import { apiResourceSchema } from '../common/schemas';
import { QueryKeys } from '../keys';
import { request } from '../request';
import { customConditionSchema } from './schemas';
import { customConditionsQueryOptions } from './useCustomConditions';

export const useCreateCustomCondition = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (body: CreateCustomConditionPayload) => {
      const response = await request('/custom-conditions', { method: 'POST', body });

      const { data: customCondition } = apiResourceSchema(customConditionSchema).parse(response);

      return customCondition;
    },
    onSuccess: (customCondition) => {
      queryClient.setQueryData(customConditionsQueryOptions.queryKey, (customConditions) => [customCondition, ...(customConditions ?? [])]);
      queryClient.invalidateQueries({ queryKey: QueryKeys.customConditions.index });
    },
  });
};
